<app-content-container data-testid="admin-event-analytics">
  <app-banner-card
    [header]="'pages.admin.eventAnalytics.banner.title' | translate"
    [headerHeight]="44"
    [breadcrumbs]="breadcrumbs"
  >
    <p class="text-sm text-shikenso-purple-base-60 -mt-2 mb-6">
      {{ 'pages.admin.eventAnalytics.banner.subtitle' | translate }}
    </p>

    <app-admin-event-analytics-filters
      [userGroups]="store.userGroups$()"
      [userGroupsLoading]="store.userGroupsLoading$()"
      (scopeChanged)="onScopeChanged($event)"
    />
  </app-banner-card>

  <mat-tab-group class="w-full profile-tab-group" [preserveContent]="true">
    <mat-tab>
      <ng-template mat-tab-label>
        <span data-testid="admin-event-analytics-tab-overview">{{
          'pages.admin.eventAnalytics.tabs.overview' | translate
        }}</span>
      </ng-template>

      <ng-template matTabContent>
        <app-admin-event-analytics-overview data-testid="admin-event-analytics-tab-panel-overview" />
      </ng-template>
    </mat-tab>

    <mat-tab>
      <ng-template mat-tab-label>
        <span data-testid="admin-event-analytics-tab-kpis">{{
          'pages.admin.eventAnalytics.tabs.kpis' | translate
        }}</span>
      </ng-template>

      <ng-template matTabContent>
        <app-admin-event-analytics-kpis data-testid="admin-event-analytics-tab-panel-kpis" />
      </ng-template>
    </mat-tab>

    <!-- TODO: Hidden for now -->
    <!-- <mat-tab [label]="'pages.admin.eventAnalytics.tabs.charts' | translate">
      <ng-template matTabContent>
        <app-admin-event-analytics-charts />
      </ng-template>
    </mat-tab> -->

    <mat-tab>
      <ng-template mat-tab-label>
        <span data-testid="admin-event-analytics-tab-groups">{{
          'pages.admin.eventAnalytics.tabs.groups' | translate
        }}</span>
      </ng-template>

      <ng-template matTabContent>
        <app-admin-event-analytics-groups data-testid="admin-event-analytics-tab-panel-groups" />
      </ng-template>
    </mat-tab>

    <mat-tab>
      <ng-template mat-tab-label>
        <span data-testid="admin-event-analytics-tab-users">{{
          'pages.admin.eventAnalytics.tabs.users' | translate
        }}</span>
      </ng-template>

      <ng-template matTabContent>
        <app-admin-event-analytics-users data-testid="admin-event-analytics-tab-panel-users" />
      </ng-template>
    </mat-tab>
  </mat-tab-group>
</app-content-container>
